// @view/panels/document/review/ReviewSections.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { ReviewSectionsPhase } from "@ps-bridge/models/documents/reviewSectionsPhase";
import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import ReviewSectionsVisibleView from "@view/document/review/ReviewSectionsVisible.view";

type ReviewSectionsPanelProps = { phase: ReviewSectionsPhase; } & Pick<DocumentReviewViewProps, "handleDraft" | "handleRefine" | "handleEdits" | "handleUpload">;

const ReviewSectionsPanel: React.FC<ReviewSectionsPanelProps> = (props) => {
  const { phase, ...viewProps } = props;
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<ReviewSectionsPhase, ReviewSectionsPhase>;
  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: <ReviewSectionsVisibleView {...viewProps} />,
  } as const satisfies Record<ReviewSectionsPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(ReviewSectionsPanel);
